import type { RequestConfig } from '@customTypes/index';
import type { ArtistWorkHistory } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistGetProfileWorkHistoryRequest = {
  profileId: string;
};

export type ArtistGetProfileWorkHistoryParams =
  RequestConfig<ArtistGetProfileWorkHistoryRequest>;

export const artistGetProfileWorkHistory = async ({
  params,
  config
}: ArtistGetProfileWorkHistoryParams) =>
  api.get<ArtistWorkHistory[]>(
    `/api/ArtistProfile/${params.profileId}/work-history`,
    config
  );
